import {
    Heading,
    Flex,
    Link,
    Text,
    TextAreaField,
    TextField,
    Button,
    Expander,
    ExpanderItem,
    Collection,
    Loader,
    View,
  } from "@aws-amplify/ui-react";
  
  export default function Audience({
    clientData,
    campaignRecord,
    handleSubmit,
    keywords,
    setKeywords,
    connections,
    isLoadingConnections,
    navigate,
  }) {
    return (
      <>
        <br />
        <br />
        {clientData &&
        clientData.subscriptionPlan &&
        clientData.subscriptionPlan !== "none" ? (
          <>
            <Heading level={4}>Step 2: Add Audience</Heading>
            {campaignRecord &&
            campaignRecord.SK &&
            campaignRecord.SK.indexOf("TARGETEDCAMPAIGN ") < 0 ? (
              <Heading level={4} fontWeight={"bold"} textAlign="center">
                Invalid campaign
              </Heading>
            ) : (
              <>
                <Flex as="form" direction="column" width="100%" id="audienceTab">
                  <br />
                  <TextAreaField
                    descriptiveText="Add one company name per line."
                    label="Companies to connect with"
                    placeholder={`Great Brand\nAnother Brand`}
                    rows={5}
                    id="companies"
                  />
                  <TextField
                    label="Keywords to search profiles for each company"
                    id="keywords"
                    placeholder={`founder OR CEO OR president OR director OR VP OR HR OR marketing`}
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                  />
                  <Expander isCollapsible={true}>
                    <ExpanderItem title="How to use Companies to connect with guide">
                      <ul>
                        <li>
                          If not empty we immediately transform this list to CONNECT tasks
                        </li>
                        <li>Write one company or brand name per line</li>
                        <li>You may add as many company or brand names at once</li>
                        <li>Write keywords to search profiles for each company</li>
                        <li>We save keywords for your future use</li>
                        <li>Perform CONNECT tasks among all other tasks</li>
                        <li>
                          Every CONNECT task will resurface in 2 weeks to be confirmed or
                          withdrawn
                        </li>
                        <li>
                          Grow your network to thousands of connections spending just minutes
                          daily
                        </li>
                        <li>Check every connection status below in Connections History</li>
                      </ul>
                    </ExpanderItem>
                  </Expander>
                  <br />
                  <br />
                  <TextAreaField
                    descriptiveText="Add one profile URL per line."
                    label="Profiles to connect with"
                    placeholder="https://www.linkedin.com/in/some-profile/"
                    rows={5}
                    id="connections"
                  />
                  <Expander isCollapsible={true}>
                    <ExpanderItem title="How to use Profiles to connect with guide">
                      <ul>
                        <li>
                          If not empty we immediately transform this list to CONNECT tasks
                        </li>
                        <li>Write one LinkedIn profile URL per line</li>
                        <li>You may add as many profile URLs as you want at once</li>
                        <li>Perform CONNECT tasks among all other tasks</li>
                        <li>
                          Every CONNECT task will resurface in 2 weeks to be confirmed or
                          withdrawn
                        </li>
                        <li>
                          Grow your network to thousands of connections spending just minutes
                          daily
                        </li>
                        <li>Check every connection status below in Connections History</li>
                      </ul>
                    </ExpanderItem>
                  </Expander>
                  <br />
                  <Button
                    onClick={() => {
                      handleSubmit("update", {
                        companies: document.getElementById("companies")?.value || "",
                        keywords: document.getElementById("keywords")?.value || "",
                        connections: document.getElementById("connections")?.value || "",
                      });
                    }}
                    variation="primary"
                  >
                    SAVE
                  </Button>
                </Flex>
                <br />
                <br />
                <br />
                <Heading level={3} fontWeight={"bold"} textAlign="center">
                  Connections History
                </Heading>
                <View align="center">
                  <Text variation="secondary">
                    List of added connections with statuses (new / pending / connected / withdrawn)
                    and date, sorted by date, with pagination and search.
                  </Text>
                  <Flex>
                    {connections.length > 0 && (
                      <Text variation="secondary">Total: {connections.length}</Text>
                    )}
                    {connections.filter((item) => item.stage === "connected").length > 0 && (
                      <Text variation="primary">
                        Connected:{" "}
                        {connections.filter((item) => item.stage === "connected").length}
                      </Text>
                    )}
                    {connections.filter((item) => item.stage === "pending").length > 0 && (
                      <Text variation="warning">
                        Pending: {connections.filter((item) => item.stage === "pending").length}
                      </Text>
                    )}
                    {connections.filter((item) => item.stage === "new").length > 0 && (
                      <Text variation="success">
                        New: {connections.filter((item) => item.stage === "new").length}
                      </Text>
                    )}
                    {connections.filter((item) => item.stage === "rejected").length > 0 && (
                      <Text variation="danger">
                        Withdrawn:{" "}
                        {connections.filter((item) => item.stage === "rejected").length}
                      </Text>
                    )}
                  </Flex>
                  <br />
                  <Button onClick={() => navigate("/campaigns")} size="small">
                    Back to Campaigns
                  </Button>
                </View>
                <br />
                <br />
                {isLoadingConnections ? (
                  <Loader variation="linear" />
                ) : (
                  <Collection
                    direction="column"
                    type="list"
                    items={connections}
                    isPaginated
                    itemsPerPage={50}
                    isSearchable
                    searchPlaceholder="Type to search..."
                  >
                    {(item, index) => (
                      <View key={index} padding="0rem">
                        <Text
                          variation={
                            item.stage === "new"
                              ? "success"
                              : item.stage === "pending"
                              ? "warning"
                              : item.stage === "connected"
                              ? "primary"
                              : "danger"
                          }
                          fontWeight="bold"
                        >
                          {item.stage}
                        </Text>
                        <Text>{item.RequestTime}</Text>
                        <Link
                          href={item.postUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.postUrl}
                        </Link>
                        <Text>{item.title}</Text>
                        <Text>{item.company}</Text>
                        <Text>{item.countryCode}</Text>
                      </View>
                    )}
                  </Collection>
                )}
              </>
            )}
          </>
        ) : (
          <Flex justifyContent="center">
            <small>
              <br />
              Unlock with subscription{" "}
              <Link href="" onClick={() => navigate("/billing")}>
                <u>here</u>
              </Link>
              <br />
              <br />
            </small>
          </Flex>
        )}
      </>
    );
  }
  